import * as React from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { checkAndRestoreSession } from "./store/auth_slice";
import { AppDispatch } from "./store/store";
import HomePage from "./pages/Home/home_page";
import DashboardPage from "./pages/Dashboard/dashboard_page";
import ProtectedRoutes from "./routes/protected_routes";
import DroneServicePage from "./pages/drones/drone_services";
import NotFoundPage from "./routes/404";
import DroneProductPage from "./pages/product_page/product_page";
import MyAccount from "./pages/account/my_account";
import MyOrders from "./pages/my_orders/my_orders";
import DroneOrderDetails from "./pages/drone_order/drone_order_status";
// import MessagingApp from "./pages/messages/messages";
import { ToastContainer } from "react-toastify"; // Importăm ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Importăm stilurile Toast
import MyListings from "./pages/my_listings/my_listings";
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const dispatch = useDispatch<AppDispatch>();

  React.useEffect(() => {
    dispatch(checkAndRestoreSession());
  }, [dispatch]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/account" element={<MyAccount />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/my-listings" element={<MyListings />} />
          <Route path="/drone-order/:orderNumber" element={<DroneOrderDetails />} />
          {/* <Route path="/messages" element={<MessagingApp />} /> */}
        </Route>
        <Route path="/drone-service/:id?" element={<DroneServicePage />} />
        <Route path="/product/:id" element={<DroneProductPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer /> {/* Adăugăm ToastContainer la nivel global */}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
